import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation, Kamitaku } from "@/mixins/index";
import * as echarts from "echarts";
import { activityRetain } from "@/api/kamitaku/kamitaku";
import { payAccountRetain, payAccountRetain_currency } from "@/api/dataAll/payAccountRetain";
import { accountRetain } from "@/api/dataAll/accountRetain";
export default {
  name: "kamitakuactivityRetain",
  mixins: [tabulation, Kamitaku],
  data: function data() {
    return {
      more: true,
      tabTypeList: [{
        label: this.$t('newUserRetention'),
        value: "accountRetain",
        fn: accountRetain
      }, {
        label: this.$t('activeUserRetention'),
        value: "activityRetain",
        fn: activityRetain
      }, {
        label: this.$t('payUserRetention'),
        value: "payAccountRetain",
        fn: payAccountRetain
      }],
      tabType: "accountRetain",
      searchData: {
        kind: 1
      },
      Dynamic: [],
      dateList: [2, 3, 4, 5, 6, 7, 14, 30, 60, 90, 120],
      myChart: null,
      dates: [],
      datas: [],
      series: [],
      tableData: [],
      reqFn: null,
      cellStylekeys: ["r"]
    };
  },
  created: function created() {},
  methods: {
    exportdata: function exportdata() {
      var _this = this;

      var d = {};
      var columns = [{
        label: this.$t('date'),
        prop: "date"
      }];

      if (this.tabType == "accountRetain") {
        columns.push({
          label: this.$t('newUserNum'),
          prop: "num"
        });
      } else if (this.tabType == "activityRetain") {
        columns.push({
          label: this.$t('loginUserNum'),
          prop: "num"
        });
      } else if (this.tabType == "payAccountRetain") {
        columns.push({
          label: this.$t('personCount'),
          prop: "num"
        });
      }

      var data = [];
      this.Dynamic.map(function (item) {
        columns.push({
          label: item.label,
          prop: item.value
        });
        d[item.value] = 0;
      });
      this.tableData.forEach(function (item) {
        var s = _objectSpread({}, d);

        for (var key in s) {
          s[key] = item["r" + key] ? item["r" + key] + " / " + item["n" + key] : item["n" + key];
        }

        s.date = item.date;
        s.num = item.num;
        data.push(s);
      });
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.tabTypeList.filter(function (item) {
          return item.value == _this.tabType;
        })[0].label
      });
    },
    getListnew: function getListnew() {
      var _this2 = this;

      this.tabChart = [];
      this.tableData = [];
      this.myChart && this.myChart.clear();

      if (this.tabType == "payAccountRetain") {
        // if (this.currencyClose && !this.searchData.currency_info) {
        //   this.$message.error('请选择货币类型')
        //   return
        // }
        this.reqFn = this.currencyClose ? payAccountRetain_currency : this.tabTypeList[this.tabTypeList.findIndex(function (item) {
          return item.value == _this2.tabType;
        })].fn;
        this.searchData = _objectSpread(_objectSpread({}, this.searchData), this.defaultData());
      } else {
        this.reqFn = this.tabTypeList[this.tabTypeList.findIndex(function (item) {
          return item.value == _this2.tabType;
        })].fn;
      }

      this.searchData.starttime = this.value2[0];
      this.searchData.endtime = this.value2[1];
      this.reqLoading = true;
      this.timeInterval();
      this.getList( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.Dynamic = [];

                if (!(_this2.tabType == "accountRetain")) {
                  _context.next = 6;
                  break;
                }

                _context.next = 4;
                return _this2.accountRetainData();

              case 4:
                _context.next = 14;
                break;

              case 6:
                if (!(_this2.tabType == "activityRetain")) {
                  _context.next = 11;
                  break;
                }

                _context.next = 9;
                return _this2.activityRetainData();

              case 9:
                _context.next = 14;
                break;

              case 11:
                if (!(_this2.tabType == "payAccountRetain")) {
                  _context.next = 14;
                  break;
                }

                _context.next = 14;
                return _this2.payAccountRetainData();

              case 14:
                _this2.getechart("n");

                _this2.$nextTick(function () {
                  _this2.getTableRight();

                  _this2.$refs.tableRef.doLayout();
                });

                _this2.reqLoading = false;

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    },
    // 新用户留存数据处理
    accountRetainData: function accountRetainData() {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        for (var key in _this3.tabData["data"]) {
          var data = {
            date: key,
            num: _this3.tabData["other"]["register_num"][key]
          };
          var length = Object.keys(_this3.tabData["data"][key]).length;

          _this3.dates.push(key);

          for (var key1 in _this3.tabData["data"][key]) {
            // if (this.dateList.findIndex((item) => item == key1) > -1) {
            // }
            data["n" + key1] = _this3.tabData["data"][key][key1] == 0 || _this3.tabData["data"][key][key1] == "/" ? "0%" : _this3.tabData["data"][key][key1];
            data["r" + key1] = _this3.tabData["retain_pnum"][key][key1] == 0 || _this3.tabData["retain_pnum"][key][key1] == "/" ? 0 : _this3.tabData["retain_pnum"][key][key1];

            if (length > _this3.Dynamic.length) {
              _this3.Dynamic.push({
                label: key1 == 2 ? _this3.$t('nextDayRetention') : _this3.$t('dayRetention', {
                  day: key1
                }),
                value: key1,
                desc: key1 == 2 ? _this3.$t('nextDayRetentionDesc') : ""
              });
            }
          }

          _this3.tabChart.push(_objectSpread({}, data));

          _this3.tableData.push(_objectSpread({}, data));
        } // 总计数据处理


        var total = {
          date: _this3.$t('weightedAverageRetention'),
          num: _this3.tabData.register_sum
        };

        for (var k in _this3.tabData.avgData) {
          total["n" + k] = _this3.zhuan([_this3.tabData.avgData[k]])[0] + "%";
        }

        _this3.tableData.push(total);

        resolve();
      });
    },
    // 活跃用户数据处理
    activityRetainData: function activityRetainData() {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        for (var key in _this4.tabData.data) {
          var data = {
            date: key,
            num: _this4.tabData.data[key]["login_pnum"]
          };
          var length = Object.keys(_this4.tabData.data[key]["retain"]).length;
          console.log(length);

          for (var key1 in _this4.tabData.data[key]["retain"]) {
            // if (this.dateList.findIndex((item) => item == key1) > -1) {
            // }
            data["n" + key1] = _this4.tabData.data[key]["retain"][key1] == 0 || _this4.tabData.data[key]["retain"][key1] == "/" ? "0%" : (_this4.tabData.data[key]["retain"][key1] * 100).toFixed(2) + "%";
            data["r" + key1] = _this4.tabData.data[key]["retain_num"][key1];

            if (length > _this4.Dynamic.length) {
              _this4.Dynamic.push({
                label: key1 == 2 ? _this4.$t('nextDayRetention') : _this4.$t('dayRetention', {
                  day: key1
                }),
                value: key1,
                desc: key1 == 2 ? _this4.$t('nextDayRetentionDesc') : ""
              });
            }
          }

          _this4.tabChart.push(data);

          _this4.tableData.push(data);
        } // 总计数据处理


        var total = {
          date: _this4.$t('weightedAverageRetention'),
          num: _this4.tabData.total_sum
        };

        for (var k in _this4.tabData.avgData) {
          total["n" + k] = _this4.zhuan([_this4.tabData.avgData[k]])[0] + "%";
        }

        _this4.tableData.push(total);

        resolve();
      });
    },
    // 付费用户留存数据处理
    payAccountRetainData: function payAccountRetainData() {
      var _this5 = this;

      return new Promise(function (resolve, reject) {
        var objToKey = function objToKey(obj) {
          return Object.keys(obj).map(function (k) {
            return k;
          });
        };

        var newData = _this5.tabData.data;

        for (var key in newData) {
          var data = {
            date: key,
            num: newData[key].pnum
          };
          var length = Object.keys(newData[key]["retain"]).length;

          for (var key1 in newData[key]["retain"]) {
            // if (this.dateList.findIndex((item) => item == key1) > -1) {
            // }
            data["n" + key1] = newData[key]["retain"][key1] == 0 || newData[key]["retain"][key1] == "/" ? "0%" : newData[key]["retain"][key1] == "0.00%" ? "0%" : newData[key]["retain"][key1];
            data["r" + key1] = newData[key]["retain_pnum"][key1] == 0 || newData[key]["retain_pnum"][key1] == "/" ? 0 : newData[key]["retain_pnum"][key1];

            if (length > _this5.Dynamic.length) {
              _this5.Dynamic.push({
                label: key1 == 2 ? _this5.$t('nextDayRetention') : _this5.$t('dayRetention', {
                  day: key1
                }),
                value: key1,
                desc: key1 == 2 ? _this5.$t('nextDayRetentionDesc') : ""
              });
            }
          }

          _this5.tabChart.push(data);

          _this5.tableData.push(data);
        } // 总计数据处理


        var total = {
          date: _this5.$t('weightedAverageRetention'),
          num: _this5.tabData.totalSum
        };

        for (var k in _this5.tabData.avgData) {
          total["n" + k] = _this5.zhuan([_this5.tabData.avgData[k]])[0] + "%";
        }

        _this5.tableData.push(total);

        resolve();
      });
    },
    zhuan: function zhuan(list) {
      var n = [];
      list.forEach(function (item) {
        n.push(item.length > 0 ? Number(item.substr(0, item.length - 1)) : 0);
      });
      return n;
    },
    getechart: function getechart() {
      var _this6 = this;

      var argument = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var seriesList = []; // data: this.Dynamic.map(items => { if (argument + items.value in item) { return item[argument + items.value] == '/' ? 0 : item[argument + items.value] } }),

      this.Dynamic.forEach(function (item, index) {
        var datalist = _this6.tabChart.map(function (items) {
          if (argument + item.value in items) {
            return items[argument + item.value] == "/" ? 0 : items[argument + item.value];
          }
        });

        seriesList.push({
          data: _this6.zhuan(datalist),
          name: item.label,
          smooth: true,
          type: "line"
        });
      });
      var chartDom = document.getElementById("kamitakuactivityRetainEchart");
      this.myChart = echarts.init(chartDom);
      var selected = {};
      this.Dynamic.forEach(function (item, index) {
        selected[item.label] = index == 0 ? true : false;
      });
      var option;
      option = {
        title: {
          text: this.tabTypeList.filter(function (item) {
            return item.value == _this6.tabType;
          })[0].label + "(%)"
        },
        animationDuration: 3000,
        tooltip: {
          confine: true,
          trigger: "axis"
        },
        legend: {
          data: this.Dynamic.map(function (item, index) {
            return item.label;
          }),
          selected: selected,
          top: 10,
          width: "80%"
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "10%",
          top: "20%",
          containLabel: true
        },
        toolbox: {
          z: 12,
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: "category",
          nameLocation: "middle",
          data: this.tabChart.map(function (item) {
            return item.date;
          })
        },
        yAxis: {
          type: "value",
          min: 0,
          max: 100
        },
        series: seriesList
      };
      option && this.myChart.setOption(option, true);
    }
  }
};